import React from "react";
import { useScrollReveal } from "hooks/useScrollReveal";

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}

/**
 * Fades/slides its children up into place the first time they scroll into
 * view. Used throughout the PPV creator landing page instead of every
 * section just appearing fully rendered.
 */
const Reveal = ({ children, delay = 0, y = 28, className = "" }: RevealProps) => {
  const { ref, visible } = useScrollReveal<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : `translateY(${y}px)`,
        transition: `opacity 700ms cubic-bezier(0.16,1,0.3,1) ${delay}ms, transform 700ms cubic-bezier(0.16,1,0.3,1) ${delay}ms`,
        willChange: "transform, opacity",
      }}
    >
      {children}
    </div>
  );
};

export default Reveal;
